import request from '@/utils/request'
import axios from 'axios'

// 初始化获取字典码信息
export function initDicData() {
  return request({
    url: 'admin/prj/company/init',
    method: 'post'
  })
}
// 安全子系统企业信息列表【分页查询】
export function companys(data) {
  return request({
    url: 'admin/prj/company/list',
    method: 'post',
    data
  })
}

// 获取安全子系统企业信息列表【无需分页】
export function getCompAll(data) {
  return request({
    url: 'admin/prj/company/getAll',
    method: 'POST',
    data
  })
}

//安全子系统企业信息列表【不用分页模糊查询】
export function getCompAllNew(data) {
  return request({
    url: 'admin/prj/company/queryList',
    method: 'POST',
    data
  })
}

// 删除
export function deleteHandle(data) {
  return request({
    url: 'admin/prj/company/delete',
    method: 'post',
    data
  })
}
// 导入
export function importCompany(data) {
  return request({
    url: 'admin/prj/company/importCompany',
    method: 'post',
    data
  })
}
// 新增
export function save(data) {
  return request({
    url: 'admin/prj/company/save',
    method: 'post',
    data
  })
}

// 修改
export function update(data) {
  return request({
    url: 'admin/prj/company/update',
    method: 'post',
    data
  })
}
// 修改
export function compUpdate(data) {
  return request({
    url: 'admin/prj/comp/update',
    method: 'post',
    data
  })
}

// 详情
export function info(id) {
  return request({
    url: 'admin/prj/company/info/' + id,
    method: 'get'
  })
}
// 详情
export function getPercentage(id) {
  return request({
    url: 'admin/prj/comp/getPercentage/' + id,
    method: 'get'
  })
}
// 详情
export function compInfo(id) {
  return request({
    url: 'admin/prj/comp/info/' + id,
    method: 'get'
  })
}

// 查询账号是否存在
export function companyUserIsExist(username) {
  return request({
    url: 'admin/prj/company/companyUserIsExist/'+username,
    method: 'get'
  })
}

// 获取中台全部【子系统合并】企业表接口
export function getCompanyInfo() {
  return axios.get(process.env.VUE_APP_MHBASE + '/api/v1/dap/dataService/serviceApi/std_company_info/439',{pageSize:999999,pageNum:1})
}

// 获取企业信息列表【无需分页】
export function getCompanyAllList(data) {
  return request({
    url: 'admin/external/company/list',
    method: 'POST',
    data
  })
}

